import React from 'react'
import RecipeProductionRatio from "./RecipeProductionRatio";
import RecipeProductionName from "./RecipeProductionName";
import RecipeProductionDelete from "./RecipeProductionDelete";

const ProductionListRows = ({id}) => {

    return(
        <React.Fragment>
            <tr>
                <td>    {Number(id) + 1}                               </td>
                <td>    <RecipeProductionName rowId={id} />            </td>
                <td>    <RecipeProductionRatio rowId={id} />           </td>
                <td>    <RecipeProductionDelete rowId={id} />          </td>
            </tr>
        </React.Fragment>
    )
}
export default ProductionListRows